import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Styles } from './style';
import { Agent, agentData } from '../UserList/agentData';
import AuthenticatedLayout from '@screens/Authenticated/Layout/Layout';

const UserEditScreen: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [formData, setFormData] = useState<Agent | null>(null);

  useEffect(() => {
    const user = agentData.find((u) => u.id === id);
    if (user) setFormData(user);
    else navigate('/area-do-corretor');
  }, [id, navigate]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    navigate('/area-do-corretor');
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    if (!formData) return;

    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  if (!formData) return <div>Carregando...</div>;

  return (
    <AuthenticatedLayout>
      <h1>EDIÇÃO DE USUÁRIO - {formData.agentName}</h1>
      <Styles.RectangleBar />
      <form onSubmit={handleSubmit}>
        <Styles.FormSection>
          <Styles.InputContainer style={{ width: '300px' }}>
            <Styles.Label>Nome Completo</Styles.Label>
            <Styles.Input
              type="text"
              name="agentName"
              value={formData.agentName}
              onChange={handleChange}
            />
          </Styles.InputContainer>

          <Styles.InputContainer style={{ width: '200px' }}>
            <Styles.Label>Tipo de Usuário</Styles.Label>
            <Styles.Select
              name="userType"
              value={formData.userType}
              onChange={handleChange}>
              <option value="Corretor">Corretor</option>
              <option value="Secretária">Secretária</option>
              <option value="Administrador">Administrador</option>
              <option value="Proprietário">Proprietário</option>
            </Styles.Select>
          </Styles.InputContainer>
          <Styles.InputContainer style={{ width: '150px' }}>
            <Styles.Label>Código</Styles.Label>
            <Styles.Input
              type="text"
              name="agentCode"
              value={formData.agentCode}
              onChange={handleChange}
            />
          </Styles.InputContainer>
        </Styles.FormSection>
        <Styles.FormSection>
          <Styles.InputContainer style={{ width: '250px' }}>
            <Styles.Label>Telefone</Styles.Label>
            <Styles.Input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
            />
          </Styles.InputContainer>
          <Styles.InputContainer style={{ width: '350px' }}>
            <Styles.Label>E-mail</Styles.Label>
            <Styles.Input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
          </Styles.InputContainer>
        </Styles.FormSection>
        <Styles.FormSection>
          <Styles.InputContainer style={{ width: '600px' }}>
            <Styles.Label>URL da Foto</Styles.Label>
            <Styles.Input
              type="url"
              name="agentPhoto"
              value={formData.agentPhoto}
              onChange={handleChange}
            />
          </Styles.InputContainer>
          <div style={{ marginLeft: '20px' }}>
            <img
              src={formData.agentPhoto}
              alt="Preview"
              style={{
                width: '100px',
                height: '100px',
                borderRadius: '50%',
                objectFit: 'cover'
              }}
            />
          </div>
        </Styles.FormSection>
        <Styles.FormSection>
          <Styles.InputContainer>
            <Styles.Label>ID</Styles.Label>
            <Styles.Input
              type="text"
              value={formData.id}
              disabled
              style={{ backgroundColor: '#f0f0f0' }}
            />
          </Styles.InputContainer>
          <Styles.InputContainer>
            <Styles.Label>Criado em</Styles.Label>
            <Styles.Input
              type="text"
              value={new Date(formData.createdAt).toLocaleDateString()}
              disabled
              style={{ backgroundColor: '#f0f0f0' }}
            />
          </Styles.InputContainer>
          <Styles.InputContainer>
            <Styles.Label>Última atualização</Styles.Label>
            <Styles.Input
              type="text"
              value={new Date(formData.updatedAt).toLocaleDateString()}
              disabled
              style={{ backgroundColor: '#f0f0f0' }}
            />
          </Styles.InputContainer>
        </Styles.FormSection>
        <Styles.FormSection>
          <Styles.Button type="submit">ATUALIZAR</Styles.Button>
          <Styles.CancelButton type="button" onClick={() => navigate(-1)}>
            CANCELAR
          </Styles.CancelButton>
        </Styles.FormSection>
      </form>
    </AuthenticatedLayout>
  );
};

export default UserEditScreen;
